import { createStore } from 'vuex'
import user from './modules/user'
import system from './modules/system'

const store = createStore({
  modules: {
    user,
    system
  },
  getters: {
    token: state => state.user.token,
    user: state => state.user.user,
    roles: state => state.user.roles,
    permissions: state => state.user.permissions,
    systemConfig: state => state.system.config,
    systemConfigLoaded: state => state.system.loaded
  }
})

export default store
